type Item = {
    // [key: string]: any,
}

function useSortList(list: any, key: string) {

    var numericPart;
    var letterPart;
    var max_chars = 4;
    var pad_char = 0;
    for (var i = 0; i < list.length; i++) {
        var listItem = list[i]
        numericPart = listItem[key].match(/\d+/);
        numericPart = (new Array(max_chars + 1).join(`${pad_char}`) + numericPart).slice(-max_chars);
        letterPart = listItem[key].match(/[A-z]+/);
        list[i][key] = letterPart + numericPart;
    }
    list.sort(function (a: any, b: any) {
        if (a[key] > b[key])
            return 1;
        if (a[key] < b[key])
            return -1;
        // a must be equal to b
        return 0;
    });
    for (var i = 0; i < list.length; i++) {
        list[i][key] = list[i][key].replace(/0+(?=[1-9])/, '');
    }
    return list

}

export default useSortList;